/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export { LocalePrefixProvider, useLocalePrefix } from "./LocalePrefixContext";
export type { LocalePrefixContextValue, LocalePrefixProviderProps } from "./LocalePrefixContext";
